var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(!_vm.loading)?_c('v-main',[(!_vm.user.username)?_c('div',[_c('LoginForm')],1):_c('div',[_c('Header'),_c('router-view')],1)]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }